(function () {
  clientApp.controller('emailsCtrl', function ($scope) {
    $scope.specialEmails = [];
    $scope.clientEmailAddresses = [{name: 'Все письма', email: ''}];
    $scope.selectedAddress = $scope.clientEmailAddresses[0];
    $scope.sizeLimit = 250;

    $scope.init = function (clientId, specialAddresses) {

      $scope.specialEmails = specialAddresses;

      $.ajax({
        url: Routing.generate('app_client_clients_getemails', { 'client': clientId }),
        success: function (data) {
          $scope.clientEmails = data;
          $scope.clientEmails.forEach(function (email) {
            var addrFrom = {'name': email.from_name, 'email': email.from_address.toLowerCase()};
            var addrTo = {'name': email.to_name, 'email': email.to_address.toLowerCase()};

            if ($scope.clientEmailAddresses.filter(function (addr) {
              return addr.email === addrFrom.email;
            }).length === 0) {
              $scope.clientEmailAddresses.push(addrFrom);
            }

            if ($scope.clientEmailAddresses.filter(function (addr) {
              return addr.email === addrTo.email;
            }).length === 0) {
              $scope.clientEmailAddresses.push(addrTo);
            }

            $scope.clientEmailAddresses.sort(function (a, b) {
              if (a.email.indexOf('restoclub') >= 0 && b.email.indexOf('restoclub') < 0)
                  return 1;
              if (b.email.indexOf('restoclub') >= 0 && a.email.indexOf('restoclud') < 0)
                  return -1;
              return 0;
            });

          });
        }
      });
    };
    
    
    $scope.selectAddress = function (address) {
      $scope.selectedAddress = address;
    };
    
    
    $scope.showEmail = function (email) {
      return ($scope.selectedAddress.email == '') || (email.from_address == $scope.selectedAddress.email) || (email.to_address == $scope.selectedAddress.email);
    };
    

    $scope.isInEmail = function (email) {
      return email.type == '1';
    };


    $scope.isSpecialEmail = function (email) {
      return $scope.specialEmails.indexOf(email.toLowerCase()) >= 0;
    };

  })
    
  .filter('nl2br', function() {
    return function(data) {
      if (!data) return data;
      return data.replace(/\n\r?/g, '<br />');
    };
  })

  .filter('sanitize', ['$sce', function($sce) {
    return function(htmlCode){
      return $sce.trustAsHtml(htmlCode);
    }
  }])

  .filter('getRestFrom', function () {
    return function (text, startPosition) {
      return text.slice(startPosition);
    }
  });
})();